const computed = require('../computed/auth');

module.exports = {
    /**
     * Устанавливаем computed поля
     * @param {Object} args
     * @param {Object} state
     */
    setComputedFields (args, state) {
        computed.setComponentsByPage(state);
        computed.setUserDataEmail(state);
    }
};



// WEBPACK FOOTER //
// ./actions/auth/index.js